import _ from "lodash";
import { Article, Article_InventoryType } from "../../../api/schema";
import { ModalInputType } from "../../../components/form/Form";
import { FormInputFields } from "../../../components/form/InputFormBuilder";
import { ParentPrettyRender } from "../../../components/ParentRenderer";
import { UserLanguage } from "../../../lang/lang";
import { LocationPrettyRender } from "../../../utils/PrettyRenderer";
import { ArticleViewResponse } from "../helper/graphql";

export const UpdateModalKeys = (
  part_view_data: ArticleViewResponse | null
): FormInputFields<Article> => ({
  id: {
    type: ModalInputType.String,
    readonly: true,
    label: UserLanguage().data.id,
  },
  name: {
    type: ModalInputType.String,
    label: UserLanguage().data.name,
  },
  matchcode: {
    type: ModalInputType.String,
    label: UserLanguage().data.article.matchcode,
  },
  display_name: {
    type: ModalInputType.String,
    label: UserLanguage().data.display_name,
  },
  footprint: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.footprint.label,
    items: part_view_data?.footprints,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.footprint.label
    ),
    itemKey: "name",
    icon: "box",
  },
  article_category: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.articleCategory.label,
    items: part_view_data?.articleCategories,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.articleCategory.label
    ),
    textRenderer: (ac) =>
      ac ? _.get(UserLanguage().data.article_categories, ac.name, ac.name) : "",
    itemKey: "name",
    icon: "folder-open",
  },
  location: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.location.label,
    items: part_view_data?.locations,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.location.label
    ),
    textRenderer: (l) => LocationPrettyRender(l),
    itemKey: "name",
    icon: "map-marker",
  },
  product_group: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.product_group.label,
    items: part_view_data?.productGroups,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.product_group.label
    ),
    textRenderer: (l) => ParentPrettyRender(l),
    itemKey: "name",
    icon: "map-marker",
  },
  inventory_type: {
    type: ModalInputType.ItemSelect,
    items: _.values(Article_InventoryType),
    label: UserLanguage().data.inventory_type.label,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.inventory_type.label
    ),
    translate: UserLanguage().data.inventory_type.types,
    defaultValue: Article_InventoryType.static,
  },
  datasheet_url: {
    type: ModalInputType.URL,
    label: UserLanguage().data.article.datasheet_url,
    icon: "document",
  },
  picture: {
    type: ModalInputType.String,
    label: UserLanguage().data.article.picture,
    icon: "mugshot",
  },
  description: {
    type: ModalInputType.Text,
    label: UserLanguage().data.description,
    icon: "clipboard",
  },
});
